export default "__VITE_ASSET__BpG2JIPm__"